export default __webpack_public_path__ + "d41ad78fb408ac3780f43967ec29e951.png";